import FormWidget from "../form-widget.js";

class CounterWidget extends FormWidget {
    public override process() {
        const fieldEl = this.element as HTMLInputElement;

        const visualContainerEl = document.createElement('div');
        visualContainerEl.setAttribute('class', 'mt-1 mb-1 badge-group char-counter-widget');
        if(fieldEl.parentElement?.classList.contains('input-group')) {
            fieldEl.parentElement?.after(visualContainerEl);
        } else {
            fieldEl.after(visualContainerEl);
        }

        const minlengthOption = fieldEl.getAttribute('minlength') ?? fieldEl.dataset.minlength ?? '0';
        const maxlengthOption = fieldEl.getAttribute('maxlength') ?? fieldEl.dataset.minlength ?? '0';

        const minlength = parseInt(minlengthOption);
        const maxlength = parseInt(maxlengthOption);

        if(minlength > 0) {
            visualContainerEl.innerHTML = '<span class="badge badge-default">'+window.ThiemeCore.Lang.translate('minLength', { min: minlength.toString() }, 'Min length: {{min}} chars')+'</span>';
        }

        if(maxlength > 0) {
            const counterEl = document.createElement('span');
            counterEl.setAttribute('class', 'badge badge-default');
            visualContainerEl.append(counterEl);
            const updateCounter = function() {
                let chars = fieldEl.value.length;
                if(fieldEl.classList.contains('is-rte')) {
                    const temp = document.createElement('div');
                    temp.innerHTML = fieldEl.value;
                    chars = (temp.textContent) ? temp.textContent.length : 0;
                }
                let rest = maxlength - chars;
                counterEl.innerHTML = window.ThiemeCore.Lang.translate('charsLeft', { rest: rest.toString() }, '{{rest}} Chars left');
            };
            fieldEl.addEventListener('keyup', () => {
                updateCounter();
            });
            fieldEl.addEventListener('change', () => {
                updateCounter();
            });

            fieldEl.addEventListener('keydown', (ev: KeyboardEvent) => {
                const keyCode = (ev.code) ? ev.code.charCodeAt(0) : ev.keyCode;
                if(
                    (fieldEl.value.length + 1) > maxlength
                    && ([8,46,35,36,37,38,39,40].indexOf(keyCode) < 0)
                ) {
                    return false;
                }

                return true;
            });
            updateCounter();
        }
    }

}

export default CounterWidget;
